import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { c2cApi } from "../../api/c2c-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import Transition from "./components/Transition";

export default function C2CckList() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const uid = localStorage.getItem("uid");
  const [list, setlist] = useState([] as any[]);
  const [loading, setLoading] = useState(true);

  //加载数据
  const loadData = async () => {
    setLoading(true);
    try {
      const data = await c2cApi.czlist({ uid, type: 1 });
      if (data.ok) {
        setlist(data.data);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="flex flex-col w-full bg-neutral-900 min-h-screen text-neutral-200">
      <AcendexLayout 
        theme="light" 
        hideBottomBar 
        mobileTopBarTitle={translate(getText("C2C存款記錄"))} 
        pcTopBarTitle={translate(getText("C2C存款記錄"))}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Transition show={!loading} enter="opacity-0" leave="opacity-0">
            <div className="bg-neutral-800 rounded-xl shadow-card overflow-hidden border border-neutral-700 transition-all hover:border-primary/30">
              <div className="p-4 bg-gradient-primary">
                <h2 className="text-xl font-semibold">{translate(getText("C2C存款記錄"))}</h2>
              </div>
              
              {loading ? (
                <div className="flex justify-center items-center py-16">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
                </div>
              ) : (
                <CenterPage list={list} />
              )}
            </div>
            
            <div className="flex justify-end mt-4">
              <button 
                onClick={loadData}
                className="flex items-center space-x-1 bg-primary/10 text-primary hover:bg-primary/20 transition-colors px-4 py-2 rounded-lg"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                <span>{translate(getText("刷新"))}</span>
              </button>
            </div>
          </Transition>
        </div>
      </AcendexLayout>
    </div>
  );
}
